import { render } from "./ShowDetailsTable.vue?vue&type=template&id=6c58a6fa&scoped=true"
import script from "./ShowDetailsTable.vue?vue&type=script&lang=js"
export * from "./ShowDetailsTable.vue?vue&type=script&lang=js"

import "./ShowDetailsTable.vue?vue&type=style&index=0&id=6c58a6fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c58a6fa"]])

export default __exports__